/** @format */

import { FunctionComponent as FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { getContentfulImage } from '../../lib/getContentfulImage';
import { ProductCard as ProductCardType } from '../../types/shared';
import { Subtitle } from '../ui/Typography';

import styled from 'styled-components';
import { GTMBannerClick } from '../../lib/google-tag-manager';
import { InboundLink } from '../ui/Link';

export const ProductCard: FC<Props> = ({ card }) => {
  const theme = useContext(ThemeContext);
  const { name, image, link } = card;

  if (!('link' in link.fields)) return;

  const label = link.fields.link.fields.id;

  return (
    <StyledLink onClick={() => GTMBannerClick(label)} href={link.fields.link.fields.slug}>
      <Container $bg={getContentfulImage(image.fields.file.url, true)}>
        <Text as="h3" $color={theme!.color.white}>
          {name}
        </Text>
      </Container>
    </StyledLink>
  );
};

type Props = {
  card: ProductCardType;
};

const StyledLink = styled(InboundLink)`
  display: block;
`;

const Container = styled.div<{ $bg: string }>`
  background-image: url(${({ $bg }) => $bg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 1.875rem;
  margin-inline: auto;
  padding: 1.25rem;
  max-width: 25rem;
  max-height: 33rem;
  aspect-ratio: 25 / 33;
  position: relative;
  text-align: center;
  display: flex;

  overflow: hidden;

  &::before {
    content: '';
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeholder;
    animation-timing-function: ease;
    border-radius: 1rem;
    position: absolute;
    inset: 0;

    z-index: -1;

    @keyframes placeholder {
      0% {
        background-color: #eeeeee3a;
      }
      50% {
        background-color: #10101039;
      }
      100% {
        background-color: #eeeeee3a;
      }
    }
  }
`;

const Text = styled(Subtitle)`
  margin-block: auto 1em;
  margin-inline: auto;
`;
